import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  accurateMigration,
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
} from "./companySlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import PreviewModal from "../../utility/PriviewImg";
import { ImageViewer } from "../../utility/ImageViewer";
import { selectUser } from "../../modules/Auth/_redux/authRedux";

export const CompanyCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectId);
  const user = useSelector(selectUser);

  const { id } = useParams();

  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [contact, setContact] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddres] = useState("");
  const [fileLogo, setFileLogo] = useState(null);

  const [show, setShow] = useState("");
  const ref = useRef();
  const [showPreview, setShowPreview] = useState(false);
  const [dataPreview, setDataPreview] = useState(false);

  const handlePreview = (data) => {
    setShowPreview(true);

    setDataPreview(data);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  const paramsId = {
    company_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setName(dataId.company_name);
      setCode(dataId.company_code);
      setContact(dataId.contact_person);
      setPhoneNumber(dataId.phone);
      setAddres(dataId.address);
    }
  }, [dataId]);

  const handleSave = async () => {
    const fields = [
      { value: name, message: "input Name", valid: true },
      { value: code, message: "input Code", valid: true },
      { value: phoneNumber, message: "input Phone", valid: true },
      { value: contact, message: "input Contact Person", valid: true },
    ];

    const errorMessage = checkEmptyFields(fields);
    if (errorMessage) {
      return showDialog(errorMessage);
    }

    if (id === undefined && fileLogo === null) {
      return showDialog("Please input foto");
    }
    const payload = {
      company_name: name,
      company_code: code,
      contact_person: contact,
      phone: phoneNumber,
      address: address,
    };

    const file = fileLogo;

    console.log(payload, file, "payloasd");

    try {
      const response =
        id === undefined
          ? await dispatch(addItem({ payload, file }))
          : await dispatch(editItem({ payload, file }));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleSynch = async () => {
    const params = {};
    try {
      const response = await dispatch(accurateMigration(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.data.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Company" : "Edit Company"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {id !== undefined && user.accurate_integrated === "ON" && (
              <Button
                className="btn btn-outline-primary mr-3"
                onClick={(e) => handleSynch()}
              >
                Accurate Synch
              </Button>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>{" "}
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Company Name<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Address</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => setAddres(e.target.value)}
                      value={address}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Logo <b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      ref={ref}
                      type="file"
                      label="Input File Name"
                      onChange={(e) => setFileLogo(e.target.files[0])}
                      custom
                      accept=".png, .jpeg"
                    />
                  </Col>
                  <Col>
                    {fileLogo && (
                      <div
                        className="btn btn-icon btn-light btn-hover-danger btn-sm mx-1 my-1"
                        onClick={() => handlePreview(fileLogo)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-secondary">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Design/Image.svg"
                            )}
                          />
                        </span>
                      </div>
                    )}
                  </Col>
                </Form.Group>
                {id && (
                  <Form.Group as={Row}>
                    <Form.Label column sm={3}></Form.Label>
                    <Col sm={6}>
                      <div style={{ maxWidth: "100%", height: "auto" }}>
                        <ImageViewer url={dataId?.logo} />
                      </div>
                    </Col>
                  </Form.Group>
                )}
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Company Code<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setCode(e.target.value.toUpperCase())}
                      value={code}
                      maxLength={4}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Contact Person<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setContact(e.target.value)}
                      value={contact}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Phone <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => {
                        const input = e.target.value;
                        const numericInput = input.replace(/\D/g, ""); // Hanya angka yang diizinkan
                        if (numericInput.length <= 13) {
                          setPhoneNumber(numericInput);
                        }
                      }}
                      value={phoneNumber}
                      maxLength={13}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>

      <PreviewModal
        show={showPreview}
        handleClose={handleClosePreview}
        data={dataPreview}
      />
    </>
  );
};
